import React from 'react'

export default function InfoCard({ data }) {
    return (

        <div class="card counter">
            <div class="card-body d-flex align-items-center">
                <div class="card-box-icon">
                    {data.iconclass && <i class={data.iconclass}></i>}
                </div>
                <div class="chart-num">
                    <h3 class="mb-0">{data.number}</h3>
                    <p class="mb-0">
                        {data.name}
                    </p>
                </div>
            </div>
        </div>
    )
}
